import React, { useMemo } from 'react';
import { ContainerTypeContext, ContainerTypeContextProps, containerTypeSlice } from '../context/ContainerTypeContext';
import { ContainerType } from '../types/container_type/containerType';
import { useAppDispatch, useAppSelector } from '../ui/pages/store';

interface ContainerTypeProviderProps {
  children: React.ReactNode;
}

export default function ContainerTypeProvider({ children }: ContainerTypeProviderProps) {
  const dispatch = useAppDispatch();
  const items = useAppSelector(state => state.containerTypes.items);
  const loading = useAppSelector(state => state.containerTypes.loading);

  const containerTypes = useMemo(() => {
    return new Map(items.map(item => [item.id, new ContainerType(item)]));
  }, [items]);

  const containerTypeContext: ContainerTypeContextProps = {
    containerTypes,
    containerTypesLoading: loading,
    setContainerTypes: (containerTypes: Map<string, ContainerType>) =>
      dispatch(containerTypeSlice.actions.setAll([...containerTypes.values()])),
  };

  return <ContainerTypeContext.Provider value={containerTypeContext}>{children}</ContainerTypeContext.Provider>;
}
